import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import get from 'lodash/get';
import log from '../../../logger';
const reducerName = 'snapshotChecker';

export const checkCanPublish = createAsyncThunk(
  `${reducerName}/checkCanPublish`,
  async ({ hasChecked, forceCheck = false }, thunkApi) => {
    const resp = { canPublish: false, emptyQ: false };
    try {
      await new Promise((r) => setTimeout(r, hasChecked ? 5000 : 5));
      const { data } = await axios.get('content-api/checkCanPublish');
      resp.canPublish = get(data, 'emptyQ', true);
      resp.emptyQ = get(data, 'emptyQ', true); // Save the actual emptyQ value
    } catch (e) {
      log.error('Error getting check publishes', e);
    } finally {
      // Only continue polling if the queue is not empty or if we're forcing a check
      if (!resp.emptyQ || forceCheck) {
        thunkApi.dispatch(checkCanPublish({ hasChecked: true }));
      }
    }
    return resp;
  }
);

// Action to restart the checking process
export const restartCanPublishCheck = createAsyncThunk(
  `${reducerName}/restartCanPublishCheck`,
  async (_, thunkApi) => {
    // Get the current state to see if checking is already active
    const state = thunkApi.getState();
    const isAlreadyChecking = get(state, `${reducerName}.isChecking`, false);

    // Only start a new check if one isn't already running
    if (!isAlreadyChecking) {
      // Dispatch the checkCanPublish action with forceCheck=true to run at least one check
      thunkApi.dispatch(checkCanPublish({ hasChecked: false, forceCheck: true }));
    }

    return { restarted: true };
  }
);
